import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _toConsumableArray from "E:/workSpace/vyj/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "E:/workSpace/vyj/node_modules/@babel/runtime/helpers/esm/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var vm = {}; //  import * as Model from './model'

export default {
  name: 'CcmsForm',
  data: function data() {
    this.turnData(this.formList);
    return {
      vm: vm,
      refForm: {},
      formModel: {
        formList: this.formList
      }
    };
  },
  props: {
    formList: Array,
    needBtn: {
      type: Boolean,
      default: true
    },
    name: String,
    split: Number,
    formItemStyle: String,
    lableWidth: String,
    selectOptionStyle: String
  },
  watch: {
    formList: function formList(val) {
      this.formModel.formList = val;
      this.turnData(this.formModel.formList);
    }
  },
  mounted: function mounted() {
    this.setAuth();
    this.refForm = this.$refs['form'];
  },
  methods: {
    //    通过一个prop字段设置另一个属性 prop tarPro要设置的目标属性值
    setProperByPro: function setProperByPro(prop, tarPro) {
      if (_typeof(tarPro) !== 'object') {
        return;
      }

      for (var i = 0; i < this.formList.length; i++) {
        if (this.formList[i].prop === prop) {
          for (var key in tarPro) {
            this.formList[i][key] = tarPro[key];
          }
        }
      }
    },
    // 通过prop 获取表单字段对象
    getPropObjByPro: function getPropObjByPro(prop) {
      for (var i = 0; i < this.formList.length; i++) {
        if (this.formList[i].prop === prop) {
          return this.formList[i];
        }
      }
    },
    // 设置权限控制
    setAuth: function setAuth() {
      this.formList.map(function (item) {
        if (typeof item.dataAuth === 'function') {
          item.dataAuth();
        }
      });
    },
    // 点击确认按钮
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (val) {
        if (val) {
          _this.$emit('clickSubmit', _this.getFormModel());
        }
      });
    },
    // 获取form model
    getFormModel: function getFormModel() {
      var workObj = {};

      for (var i = 0; i < this.$refs['form'].model.formList.length; i++) {
        var obj = this.$refs['form'].model.formList[i];
        workObj[obj.prop] = obj.model;
      }

      return workObj;
    },
    // 获取form model //必要index字段
    getSpecialFormModel: function getSpecialFormModel() {
      var formList = this.$refs['form'].model.formList;
      var map = formList.map(function (_ref) {
        var index = _ref.index;
        return index;
      });
      var max = Math.max.apply(Math, _toConsumableArray(map));
      var arr = [];

      if (max === 0) {
        var workObj = {};
        formList.forEach(function (item) {
          return workObj[item.prop] = item.itemType === 'date' ? new Date(item.model).getTime() : item.model;
        });
        arr.push(workObj);
      } else {
        var _loop = function _loop(i) {
          var workObj = {};
          var filter = formList.filter(function (_ref2) {
            var index = _ref2.index;
            return index === i;
          });
          filter.forEach(function (item) {
            workObj[item.prop] = item.itemType === 'date' ? new Date(item.model).getTime() : item.model;
          });
          arr.push(workObj);
        };

        for (var i = 0; i <= max; i++) {
          _loop(i);
        }
      }

      console.log(arr);
      return {
        list: arr
      };
    },
    // 重置表单
    reset: function reset() {
      this.$refs.form.resetFields();
    },
    // 点击取消按钮
    clickCancel: function clickCancel() {
      this.$emit('clickCancel', this.$refs['form']);
    },
    // 当一个表单域从enable 变为disabled时 enabled错误信息不显示
    hiddenMsg: function hiddenMsg() {
      for (var i = 0; i < this.formList.length; i++) {
        if (this.formList[i].disabled) {
          this.formList[i].hiddenMsg = true;
        } else {
          this.formList[i].hiddenMsg = false;
        }
      }
    },
    selectChange: function selectChange(fun, val) {
      if (typeof fun === 'function') {
        fun(val);
      }

      this.setAuth();
      this.hiddenMsg();
    },
    turnData: function turnData(formList) {
      for (var i = 0; i < formList.length; i++) {
        var item = formList[i];

        if (item.show === undefined) {
          item.show = true;
        }

        if (item.disabled === undefined) {
          item.disabled = false;
        }
      }
    }
  }
};